import { Theme } from "@mui/material";

export const VariantStyles = (theme: Theme) => {
    return {
      applicationPending: {
        color: theme.colors["blue.400"],
      },
      onStandByList: {
        color: theme.colors["yellow.300"]
      },
      ticketOffer: {
        color: theme.colors["yellow.300"]
      },
      offerExpired: {
        color: theme.colors["red.500"]
      },
      turnedAway: {
        color: theme.colors["neutral.500"]
      },
      pastShow: {
        color: theme.colors["neutral.500"]
      },
      tickets: {
        color: theme.colors["lime.300"]
      },
      ticketAccepted: {
        color: theme.colors["lime.400"]
      },
      attended: {
        color: theme.colors["lime.400"]
      },
      noShow: {
        color: theme.colors["red.500"]
      },
      declined: {
        color: theme.colors["red.500"]
      },
      timedout: {
        color: theme.colors["red.500"]
      },
      timedoutSms: {
        color: theme.colors["red.500"]
      },
      awaitingResponse: {
        color: theme.colors["neutral.50"]
      },
      checkInPending: {
        color: theme.colors["neutral.50"]
      },
      checkedIn: {
        color: theme.colors["lime.300"]
      },
      checkInDeclined: {
        color: theme.colors["red.500"]
      },
      ticketOrInterestRevoked: {
        color: theme.colors["red.500"]
      },
      rejoinedQueue: {
        color: theme.colors["blue.400"]
      },
      lastMinQueue: {
        color: theme.colors["yellow.300"]
      },
      interestDeclined: {
        color: theme.colors["red.500"]
      },
      secondChanceOffer: {
        color: theme.colors["yellow.300"]
      },
      secondChanceExpired: {
        color: theme.colors["red.500"]
      },
      lastMinInvitedDirectly: {
        color: theme.colors["neutral.50"]
      },
    };
  };

export const SizeStyles = (theme: Theme) => {
    return {
        sm: {
            fontSize: theme.fontSizes.xs,
        },
        md: {
            fontSize: theme.fontSizes.sm,
        },
        lg: {
            fontSize: theme.fontSizes.md,
        }
    };
};